import styled from 'styled-components';

import SettingsIcon from 'assets/icons/nav/icon-settings-16.svg';

import { ExternalLink } from 'basics/links';

import { commonMaxWidth, flexRowSpaceBetween, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS, hexWithOpacity, Z_INDEX } from 'styles/style-constants';

export const MainBlock = styled.main`
    flex: 1 0 auto;
    background-color: ${COLORS.sectionBackground};
    z-index: 1;

    &:has([data-fullscreen='true']) {
        z-index: ${Z_INDEX.modal};
    }
`;

export const Background = styled.div`
    width: 100%;
    padding: 4rem 0 6rem;
    background-color: ${COLORS.sectionBackground};

    ${respondDown(Breakpoints.md)`
        padding: 1.6rem 0;
    `}
`;

export const Section = styled.section<{ $smallTopPadding?: boolean }>`
    ${commonMaxWidth};
    padding-top: ${({ $smallTopPadding }) => ($smallTopPadding ? '2rem' : '2.8rem')};
    padding-left: 4rem;
    padding-right: calc(10vw + 20rem);
    width: 100%;

    &:last-child {
        margin-bottom: 6.6rem;
    }

    ${respondDown(Breakpoints.xxxl)`
        padding-right: calc(10vw + 30rem);
    `}

    ${respondDown(Breakpoints.xxl)`
        padding-right: calc(10vw + 40rem);
    `}

    ${respondDown(Breakpoints.lg)`
        padding: 3.2rem 1.6rem 0;
    `}
`;

export const SectionWrap = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${COLORS.surface};
    padding: 4.2rem 3.2rem 4.2rem;
    border-radius: 2.4rem;

    ${respondDown(Breakpoints.md)`
        padding: 3.2rem 1.6rem;
    `}
`;

export const PoolDetailsWrap = styled(SectionWrap)`
    padding-top: 4.8rem;
    padding-bottom: 4.8rem;

    ${respondDown(Breakpoints.md)`
        padding: 3.2rem 1.6rem;
    `}
`;

export const Rewards = styled.div`
    ${flexRowSpaceBetween};

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        gap: 2rem;
    `}
`;

export const RewardsDescription = styled.div`
    display: flex;
    flex-direction: column;
    color: ${COLORS.textTertiary};
    font-weight: 700;
    font-size: 2.6rem;

    span:first-child {
        font-size: 1.6rem;
        line-height: 2.8rem;
        color: ${COLORS.textPrimary};
        margin-bottom: 0.8rem;
    }

    ${respondDown(Breakpoints.md)`
        align-items: center;
    `}
`;

export const IncentiveAmount = styled.span`
    &:not(:last-child) {
        margin-bottom: 1.6rem;
    }
`;

export const Links = styled.div`
    display: flex;
    gap: 0.8rem;
    flex-wrap: wrap;
    margin-top: 2.4rem;
`;

export const ExternalLinkStyled = styled(ExternalLink)`
    padding: 0.4rem 1.6rem;
    border-radius: 1.2rem;
    background: ${hexWithOpacity(COLORS.purple500, 5)};
    gap: 0.8rem;

    &:hover {
        background: ${hexWithOpacity(COLORS.purple500, 10)};
    }
`;

export const SettingsIconPurple = styled(SettingsIcon)`
    path {
        stroke: ${COLORS.purple500};
    }
`;

export const PageHeader = styled.div`
    ${flexRowSpaceBetween};
    align-items: center;
    margin-bottom: 7.2rem;

    ${respondDown(Breakpoints.md)`
        margin-bottom: 3.2rem;
    `}
`;
